import { http } from '../../config/axios'

export default function getClienteService(id:string) :Promise<any>{
    return http.get('/api/client/findbyid/' + id )
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
        console.error('Erro ao getClienteService')
        return new Blob()
    })
}